import React from 'react'

import { Helmet } from 'react-helmet'

import './privacy.css'

const Privacy = (props) => {
  return (
    <div className="privacy-container">
      <Helmet>
        <title>
          Privacy - FutureHeirs | Faith-Based Non-Profit Empowering Future
          Leaders
        </title>
        <meta
          name="description"
          content="Faith-based non-profit bridging quality education and accessibility. Empowering children through Christ-centered learning, tech literacy &amp; character development"
        />
        <meta
          property="og:title"
          content="Privacy - FutureHeirs | Faith-Based Non-Profit Empowering Future Leaders"
        />
        <meta
          property="og:description"
          content="Bridging quality education and accessibility through Christ-centered learning. Empowering every child to flourish in their unique calling with faith and innovation."
        />
        <meta
          property="og:image"
          content="https://aheioqhobo.cloudimg.io/v7/_playground-bucket-v2.teleporthq.io_/97765a8c-e132-4703-821d-7a550778f912/2688ccf9-cb16-49f3-aba4-ad25e1010654?org_if_sml=1&amp;force_format=original"
        />
      </Helmet>
      <div className="privacy-privacy-policy">
        <div className="privacy-frame12">
          <div className="privacy-frame14">
            <div className="privacy-frame162">
              <img
                alt="VectorI314"
                src="/external/vectori314-sed.svg"
                className="privacy-vector1"
              />
              <span className="privacy-text100">futureheirs</span>
            </div>
            <div className="privacy-frame81">
              <div className="privacy-frame6">
                <span className="privacy-text101">Home</span>
              </div>
              <div className="privacy-frame7">
                <span className="privacy-text102">About Us</span>
              </div>
              <div className="privacy-frame82">
                <span className="privacy-text103">Contact Us</span>
              </div>
              <div className="privacy-frame9">
                <span className="privacy-text104">Blog</span>
              </div>
            </div>
            <div className="privacy-component4">
              <span className="privacy-text105">Join Us</span>
            </div>
          </div>
          <div className="privacy-frame13">
            <div className="privacy-frame195">
              <img
                alt="Line653142"
                src="/external/line653142-97de.svg"
                className="privacy-line65"
              />
              <span className="privacy-text106">Privacy Policy</span>
            </div>
            <span className="privacy-text107">
              Learn how we collect, use, and protect your personal information
              to ensure your privacy and security.
            </span>
          </div>
        </div>
        <img
          alt="Rectangle43142"
          src="/external/rectangle43142-ir57.svg"
          className="privacy-rectangle4"
        />
        <div className="privacy-frame29881">
          <div className="privacy-frame29871">
            <div className="privacy-frame1144">
              <div className="privacy-frame218">
                <span className="privacy-text108">Introduction</span>
                <span className="privacy-text109">
                  FutureHeirs (&quot;we,&quot; &quot;our,&quot; or
                  &quot;us&quot;) is committed to protecting your privacy. This
                  Privacy Policy explains how we collect, use, disclose, and
                  safeguard your information when you visit our website or use
                  our services. Please read this privacy policy carefully. If
                  you do not agree with the terms of this privacy policy, please
                  do not access the site.
                </span>
              </div>
              <div className="privacy-frame220">
                <span className="privacy-text110">Information We Collect</span>
                <div className="privacy-frame11491">
                  <div className="privacy-frame11451">
                    <span className="privacy-text111">
                      Personal Information
                    </span>
                    <span className="privacy-text112">
                      <span>
                        We may collect personal information that you voluntarily
                        provide to us when you:
                      </span>
                      <br></br>
                      <span>Register for an account</span>
                      <br></br>
                      <span>Sign up for our newsletter</span>
                      <br></br>
                      <span>Make a donation</span>
                      <br></br>
                      <span>Apply to volunteer</span>
                      <br></br>
                      <span>Request information about our programs</span>
                      <br></br>
                      <span>Contact us with inquiries or feedback</span>
                      <br></br>
                      <br></br>
                      <span>This information may include:</span>
                      <br></br>
                      <span>Name</span>
                      <br></br>
                      <span>Email address</span>
                      <br></br>
                      <span>Postal address</span>
                      <br></br>
                      <span>Phone number</span>
                      <br></br>
                      <span>Payment information</span>
                      <br></br>
                      <span>Demographic information</span>
                      <br></br>
                      <span>Employment information (for volunteers)</span>
                      <br></br>
                      <span>
                        Educational background (for program participants)
                      </span>
                    </span>
                  </div>
                  <div className="privacy-frame11471">
                    <span className="privacy-text145">
                      Information Collected Automatically
                    </span>
                    <span className="privacy-text146">
                      <span>
                        When you visit our website, we may use cookies, web
                        beacons, tracking pixels, and other tracking
                        technologies to collect information about your browsing
                        activities. This information may include:
                      </span>
                      <br></br>
                      <span>IP address</span>
                      <br></br>
                      <span>Browser type</span>
                      <br></br>
                      <span>Operating system</span>
                      <br></br>
                      <span>Referring URLs</span>
                      <br></br>
                      <span>Device information</span>
                      <br></br>
                      <span>Location information</span>
                      <br></br>
                      <span>Site navigation patterns</span>
                    </span>
                  </div>
                </div>
              </div>
              <div className="privacy-frame224">
                <span className="privacy-text162">
                  How We Use Your Information
                </span>
                <span className="privacy-text163">
                  <span>
                    We may use the information we collect for various purposes,
                    including:
                  </span>
                  <br></br>
                  <span>
                    Providing, maintaining, and improving our services
                  </span>
                  <br></br>
                  <span>Processing donations and issuing tax receipts</span>
                  <br></br>
                  <span>
                    Communicating with you about programs, events, and
                    fundraising
                  </span>
                  <br></br>
                  <span>Responding to your inquiries and service requests</span>
                  <br></br>
                  <span>Sending newsletters and other communications</span>
                  <br></br>
                  <span>Analyzing usage patterns to improve our website</span>
                  <br></br>
                  <span>
                    Preventing fraudulent activities and enhancing security
                  </span>
                  <br></br>
                  <span>Complying with legal obligations</span>
                </span>
              </div>
              <div className="privacy-frame229">
                <div className="privacy-frame2989">
                  <span className="privacy-text181">
                    Sharing Your Information
                  </span>
                  <span className="privacy-text182">
                    We may share your information with:
                  </span>
                </div>
                <div className="privacy-frame11492">
                  <div className="privacy-frame11452">
                    <span className="privacy-text183">Service Providers</span>
                    <span className="privacy-text184">
                      We may share your information with third-party vendors,
                      service providers, contractors, or agents who perform
                      services for us or on our behalf.
                    </span>
                  </div>
                  <div className="privacy-frame11472">
                    <span className="privacy-text185">Legal Requirements</span>
                    <span className="privacy-text186">
                      We may disclose your information in response to a
                      subpoena, court order, or other governmental request.
                    </span>
                  </div>
                  <div className="privacy-frame11481">
                    <span className="privacy-text187">
                      Protection of Rights
                    </span>
                    <span className="privacy-text188">
                      We may disclose your information when we believe in good
                      faith that disclosure is necessary to protect our rights,
                      protect your safety or the safety of others, investigate
                      fraud, or respond to a government request.
                    </span>
                  </div>
                  <div className="privacy-frame11493">
                    <span className="privacy-text189">Non-Profit Partners</span>
                    <span className="privacy-text190">
                      With your consent, we may share your information with
                      partner organizations that align with our mission to
                      provide educational opportunities.
                    </span>
                  </div>
                </div>
              </div>
              <div className="privacy-frame225">
                <span className="privacy-text191">Data Security</span>
                <span className="privacy-text192">
                  We implement appropriate technical and organizational measures
                  to protect the security of your personal information. However,
                  please be aware that no security measures are perfect or
                  impenetrable. We cannot guarantee that your information will
                  not be accessed, disclosed, altered, or destroyed by breach of
                  any of our physical, technical, or managerial safeguards.
                </span>
              </div>
              <div className="privacy-frame226">
                <span className="privacy-text193">Children&apos;s Privacy</span>
                <span className="privacy-text194">
                  <span>
                    Our website and services are not intended for children under
                    13 years of age. We do not knowingly collect personal
                    information from children under 13. If you are a parent or
                    guardian and believe your child has provided us with
                    personal information, please contact us at
                    privacy@futureheirs.org.
                  </span>
                  <br></br>
                  <span>
                    For children participating in our programs who are under 18,
                    we collect information only with parental/guardian consent
                    and in accordance with applicable laws regarding the
                    protection of children&apos;s privacy.
                  </span>
                </span>
              </div>
              <div className="privacy-frame230">
                <span className="privacy-text198">Your Rights and Choices</span>
                <div className="privacy-frame11494">
                  <div className="privacy-frame11453">
                    <span className="privacy-text199">Access and Control</span>
                    <span className="privacy-text200">
                      You may request access to your personal information,
                      correct inaccurate data, or request deletion of your
                      information by contacting us at privacy@futureheirs.org.
                    </span>
                  </div>
                  <div className="privacy-frame11473">
                    <span className="privacy-text201">
                      Communication Preferences
                    </span>
                    <span className="privacy-text202">
                      You can opt out of receiving our newsletters and
                      promotional communications by clicking the
                      &quot;unsubscribe&quot; link in any email or by contacting
                      us.
                    </span>
                  </div>
                  <div className="privacy-frame11482">
                    <span className="privacy-text203">Cookies</span>
                    <span className="privacy-text204">
                      Most web browsers are set to accept cookies by default.
                      You can usually choose to set your browser to remove or
                      reject cookies. Please note that such actions could affect
                      the availability and functionality of our website.
                    </span>
                  </div>
                </div>
              </div>
              <div className="privacy-frame228">
                <span className="privacy-text205">
                  Changes to This Privacy Policy
                </span>
                <span className="privacy-text206">
                  We may update this privacy policy from time to time. The
                  updated version will be indicated by an updated &quot;Last
                  Updated&quot; date and the updated version will be effective
                  as soon as it is accessible. We encourage you to review this
                  privacy policy frequently to be informed of how we are
                  protecting your information.
                </span>
              </div>
              <div className="privacy-frame231">
                <span className="privacy-text207">Contact Us</span>
                <span className="privacy-text208">
                  <span>
                    If you have questions or concerns about this privacy policy
                    or our privacy practices, please contact us at:
                  </span>
                  <br></br>
                  <span>
                    FutureHeirs  123 Faith &amp; Innovation Way  Your City,
                    State 12345  privacy@futureheirs.org  (555) 123-4567
                  </span>
                </span>
              </div>
            </div>
            <div className="privacy-frame29861">
              <img
                alt="Line693142"
                src="/external/line693142-l67k.svg"
                className="privacy-line69"
              />
              <img
                alt="Line703142"
                src="/external/line703142-o6uj.svg"
                className="privacy-line70"
              />
              <div className="privacy-frame2968">
                <div className="privacy-frame29661">
                  <img
                    alt="Ellipse1803142"
                    src="/external/ellipse1803142-p93-200w.png"
                    className="privacy-ellipse1801"
                  />
                </div>
                <span className="privacy-text212">Introduction</span>
              </div>
              <div className="privacy-frame29882">
                <div className="privacy-frame29851">
                  <div className="privacy-frame29662">
                    <img
                      alt="Ellipse1803162"
                      src="/external/ellipse1803162-9une-200h.png"
                      className="privacy-ellipse1802"
                    />
                  </div>
                </div>
                <div className="privacy-frame11561">
                  <span className="privacy-text213">
                    Information We Collect
                  </span>
                  <div className="privacy-frame11551">
                    <span className="privacy-text214">
                      Personal Information
                    </span>
                    <span className="privacy-text215">
                      Information Collected Automatically
                    </span>
                  </div>
                </div>
              </div>
              <div className="privacy-frame2970">
                <div className="privacy-frame29821"></div>
                <span className="privacy-text216">
                  How We Use Your Information
                </span>
              </div>
              <div className="privacy-frame2975">
                <div className="privacy-frame29852">
                  <div className="privacy-frame29721"></div>
                </div>
                <div className="privacy-frame11562">
                  <span className="privacy-text217">
                    Sharing Your Information
                  </span>
                  <div className="privacy-frame11552">
                    <span className="privacy-text218">Service Providers</span>
                    <span className="privacy-text219">Legal Requirements</span>
                    <span className="privacy-text220">
                      Protection of Rights
                    </span>
                    <span className="privacy-text221">Non-Profit Partners</span>
                  </div>
                </div>
              </div>
              <div className="privacy-frame29872">
                <div className="privacy-frame29822"></div>
                <span className="privacy-text222">Data Security</span>
              </div>
              <div className="privacy-frame29862">
                <div className="privacy-frame29823"></div>
                <span className="privacy-text223">Children&apos;s Privacy</span>
              </div>
              <div className="privacy-frame2977">
                <div className="privacy-frame29853">
                  <div className="privacy-frame29722"></div>
                </div>
                <div className="privacy-frame1158">
                  <span className="privacy-text224">
                    Your Rights and Choices
                  </span>
                  <div className="privacy-frame1157">
                    <span className="privacy-text225">Access and Control</span>
                    <span className="privacy-text226">
                      Communication Preferences
                    </span>
                    <span className="privacy-text227">Cookies</span>
                  </div>
                </div>
              </div>
              <div className="privacy-frame2984">
                <div className="privacy-frame29824"></div>
                <span className="privacy-text228">
                  Changes to This Privacy Policy
                </span>
              </div>
              <div className="privacy-frame29854">
                <div className="privacy-frame29825"></div>
                <span className="privacy-text229">Contact Us</span>
              </div>
            </div>
          </div>
          <div className="privacy-frame189">
            <div className="privacy-frame184">
              <div className="privacy-group107">
                <span className="privacy-text230">Company</span>
                <div className="privacy-frame2491">
                  <span className="privacy-text231">Home</span>
                  <span className="privacy-text232">About Us</span>
                  <span className="privacy-text233">Contact Us</span>
                  <span className="privacy-text234">Programs</span>
                  <span className="privacy-text235">Approach</span>
                </div>
              </div>
              <div className="privacy-group106">
                <span className="privacy-text236">Quick Links</span>
                <div className="privacy-frame2492">
                  <span className="privacy-text237">Partner with Us</span>
                  <span className="privacy-text238">Volunteer</span>
                  <span className="privacy-text239">Donate</span>
                  <span className="privacy-text240">Blog</span>
                </div>
              </div>
              <div className="privacy-group105">
                <span className="privacy-text241">Terms and Policies</span>
                <div className="privacy-frame248">
                  <span className="privacy-text242">Privacy Policy</span>
                  <span className="privacy-text243">Terms and Conditions</span>
                  <span className="privacy-text244">Feedback</span>
                  <span className="privacy-text245">FAQs</span>
                </div>
              </div>
              <div className="privacy-group104">
                <span className="privacy-text246">Contact Information</span>
                <div className="privacy-group87">
                  <span className="privacy-text247">
                    connect@futureheirs.org
                  </span>
                  <div className="privacy-vuesaxboldsms1">
                    <div className="privacy-vuesaxboldsms2">
                      <div className="privacy-sms">
                        <img
                          alt="VectorI314"
                          src="/external/vectori314-2af.svg"
                          className="privacy-vector2"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="privacy-group88">
                  <span className="privacy-text248">
                    123 Faith &amp; Innovation Way, Your City, State 12345
                  </span>
                  <div className="privacy-vuesaxboldlocation1">
                    <div className="privacy-vuesaxboldlocation2">
                      <img
                        alt="VectorI314"
                        src="/external/vectori314-2dxo.svg"
                        className="privacy-vector3"
                      />
                    </div>
                  </div>
                </div>
                <div className="privacy-group89">
                  <span className="privacy-text249">(555) 123-4567</span>
                  <div className="privacy-vuesaxboldcall1">
                    <div className="privacy-vuesaxboldcall2">
                      <div className="privacy-call">
                        <img
                          alt="VectorI314"
                          src="/external/vectori314-qv1c.svg"
                          className="privacy-vector4"
                        />
                        <img
                          alt="VectorI314"
                          src="/external/vectori314-zh2t.svg"
                          className="privacy-vector5"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <img
              alt="Line2I314"
              src="/external/line2i314-owo.svg"
              className="privacy-line2"
            />
            <div className="privacy-frame183">
              <div className="privacy-frame161">
                <img
                  alt="VectorI314"
                  src="/external/vectori314-lmvh.svg"
                  className="privacy-vector6"
                />
                <span className="privacy-text250">futureheirs</span>
              </div>
              <div className="privacy-frame180">
                <span className="privacy-text251">Follow Us:</span>
                <div className="privacy-frame177">
                  <div className="privacy-vuesaxboldfacebook1">
                    <div className="privacy-vuesaxboldfacebook2">
                      <div className="privacy-facebook">
                        <img
                          alt="VectorI314"
                          src="/external/vectori314-x95h.svg"
                          className="privacy-vector7"
                        />
                      </div>
                    </div>
                  </div>
                  <img
                    alt="riinstagramfillI314"
                    src="/external/riinstagramfilli314-thf.svg"
                    className="privacy-riinstagramfill"
                  />
                  <img
                    alt="pajamaslinkedinI314"
                    src="/external/pajamaslinkedini314-v5od.svg"
                    className="privacy-pajamaslinkedin"
                  />
                  <img
                    alt="fa6brandssquarextwitterI314"
                    src="/external/fa6brandssquarextwitteri314-mb3j.svg"
                    className="privacy-fa6brandssquarextwitter"
                  />
                  <div className="privacy-vuesaxboldyoutube1">
                    <div className="privacy-vuesaxboldyoutube2">
                      <div className="privacy-youtube">
                        <img
                          alt="VectorI314"
                          src="/external/vectori314-usfbh.svg"
                          className="privacy-vector8"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Privacy
